import {Component, OnInit} from '@angular/core';
import {PublisherDashboardService} from '../../dashboard/publisher-dashboard.service';
import {Principal} from '../../../shared/auth/principal.service';
import {MatTableDataSource} from '@angular/material/table';
import {PodcastClip, RSSFeed} from '../../../shared/domain/rss.model';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {PodcastClipEditDialogComponent} from './podcast-clip-edit-dialog.component';
import {GlobalSpinnerService} from '../../../shared/components/loader-service/global-spinner.service';
import {environment} from '../../../../environments/environment';
import {map, startWith} from 'rxjs/operators';
import {SnackBarService} from '../../../shared/services/snackbar.service';
import {DeleteDialogComponent} from '../../../shared/components/dialogs/delete-dialog.component';


@Component({
  selector: 'cm-promocast',
  templateUrl: './promocast.component.html',
  styleUrls: ['./promocast.component.scss']
})
export class PromocastComponent implements OnInit {
  podcastClipsDataSource = new MatTableDataSource<PodcastClip>();
  rssFeedsDataSource = new MatTableDataSource<RSSFeed>();

  rssFeedColumns = ['name', 'url',  'status', 'enabled', 'actions'];

  podcastClipColumns = ['seriesName', 'episodeName', 'itemDuration', 'audio', 'clickThroughUrl', 'channelLanguage', 'channelImage', 'status', 'enabled', 'actions'];
  rssFeedLoading: any;
  podcastClipsLoading: any;

  languageCodes: Map<String, String>;

  constructor(private dashboardService: PublisherDashboardService, public principal: Principal, private matDialog: MatDialog, private spinnerService: GlobalSpinnerService, private sbs: SnackBarService) { }


  ngOnInit() {
    this.refreshData();


  }

  async getJsonData(url: string): Promise<any> {
    const response = await fetch(url);
    const data = await response.json();
    return data;
  }

  enroll() {
    this.spinnerService.showLoader();

    this.dashboardService.enrollInPromocast().subscribe(data => {
      this.principal.publisher = data;
      this.spinnerService.hideLoader();
    });
  }

  refreshData() {
    this.rssFeedLoading = true;
    this.dashboardService.getRssFeeds().subscribe(data => {
      this.rssFeedsDataSource.data = data;
      this.rssFeedLoading = false;
    });

    this.podcastClipsLoading = true;
    this.getJsonData(`${environment.publisherApiUrl}/country-codes`).then(data => {
      this.languageCodes = new Map<string, string>();

      for (const property in data) {
        this.languageCodes.set(property, data[property]);
      }
      this.dashboardService.getPodcastClips().subscribe(clips => {
        this.podcastClipsDataSource.data = clips;
        this.podcastClipsLoading = false;
      });
    });
  }



  addPodcastClip() {
    const rss = new PodcastClip();
    this.matDialog.open(PodcastClipEditDialogComponent, <MatDialogConfig>{
      data: {
        record: Object.assign({}, rss),
        isUpdate: false,
        languageCodes: this.languageCodes,
        type: 'AUDIO_FILE'
      },

      width: '400px'
    }).afterClosed().subscribe(next => {
      if (next) {
        this.podcastClipsDataSource.data = next;
      }
    });
  }

  updatePodcastClip(rssFeed: PodcastClip) {

    this.matDialog.open(PodcastClipEditDialogComponent, <MatDialogConfig>{
      data: {
        record: Object.assign({}, rssFeed),
        isUpdate: true,
        languageCodes: this.languageCodes,
        type: 'AUDIO_FILE'
      },

      width: '600px'
    }).afterClosed().subscribe(next => {
      if (next) {
        this.podcastClipsDataSource.data = next;
      }
    });
  }

  addRssFeedUrl() {
    const rss = new RSSFeed();
    this.matDialog.open(PodcastClipEditDialogComponent, <MatDialogConfig>{
      data: {
        rss_record: Object.assign({}, rss),
        isUpdate: false,
        languageCodes: this.languageCodes,
        type: 'RSS_FEED'
      },

      width: '400px'
    }).afterClosed().subscribe(next => {
      if (next) {
        this.rssFeedsDataSource.data = next;
      }
    });
  }

  updateRssFeed(rssFeed: RSSFeed) {

    this.matDialog.open(PodcastClipEditDialogComponent, <MatDialogConfig>{
      data: {
        rss_record: Object.assign({}, rssFeed),
        isUpdate: true,
        type: 'RSS_FEED'
      },

      width: '400px'
    }).afterClosed().subscribe(next => {
      if (next) {
        this.rssFeedsDataSource.data = next;
      }
    });
  }

  deleteRssFeed(element) {
    this.matDialog.open(DeleteDialogComponent, <MatDialogConfig>{
      data: {
        title: element.name,
        subtitle: 'Are you sure you want to delete this record?',
        confirmButtonText: 'Yes, delete!'
      }
    }).afterClosed().subscribe(next => {
      if (next) {
        this.rssFeedLoading = true;
        this.dashboardService.deleteRssFeed(element).subscribe(data => {
          this.rssFeedsDataSource.data = data;
          this.rssFeedLoading = false;
        });
      }
    });
  }

  deletePodcastClip(element) {

    this.matDialog.open(DeleteDialogComponent, <MatDialogConfig>{
      data: {
        title: element.name,
        subtitle: 'Are you sure you want to delete this record?',
        confirmButtonText: 'Yes, delete!'
      }
    }).afterClosed().subscribe(next => {
      if (next) {
        this.podcastClipsLoading = true;
        this.dashboardService.deletePodcastClip(element).subscribe(data => {
          this.podcastClipsDataSource.data = data;
          this.podcastClipsLoading = false;
        });
      }
    });
  }

  update(element, event) {
    element.enabled = event.target.checked;
    this.dashboardService.updatePodcastClip(element, null, null).subscribe(next => {
      this.spinnerService.hideLoader();
      if (next) {
        this.podcastClipsDataSource.data = next;
      }
    }, error => {
      this.sbs.error(error.error.error.messages[0]);
      this.spinnerService.hideLoader();
    });
  }

  updateFeedEnabled(element, event) {
    element.enabled = event.target.checked;
    this.dashboardService.updateFeed(element).subscribe(next => {
      this.spinnerService.hideLoader();
      if (next) {
        this.rssFeedsDataSource.data = next;
      }
    }, error => {
      this.sbs.error(error.error.error.messages[0]);
      this.spinnerService.hideLoader();
    });
  }
}
